import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ItineraryActions } from '@app/core/ngrx/actions';
import { State } from '@app/core/ngrx/reducers';
import { itinerarySelectors, userSelectors } from '@app/core/ngrx/selectors';
import { ApplicationService } from '@app/core/services/application/application.service';
import { ModalService } from '@app/core/services/modal/modal.service';
import { ProgramService } from '@app/core/services/program/program.service';
import { WarningService } from '@app/core/services/warning/warning.service';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons';
import { faBookMedical, faBriefcaseMedical, faLaptopMedical, faMapMarkerAlt, faNotesMedical, faTooth, faUserNurse } from '@fortawesome/pro-solid-svg-icons';
import { IonSelect, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-application-chain-item',
    templateUrl: './application-chain-item.component.html',
    styleUrls: ['./application-chain-item.component.scss'],
})
export class ApplicationChainItemComponent implements OnChanges {
    @Input() chainItem: any;
    @Input() index: number;

    @ViewChild(IonSelect) select: IonSelect;

    faNotesMedical = faNotesMedical;
    faMapMarkerAlt = faMapMarkerAlt;
    faStethoscope = faStethoscope;
    faBookMedical = faBookMedical;
    faBriefcaseMedical = faBriefcaseMedical;
    faLaptopMedical = faLaptopMedical;
    faTooth = faTooth;
    faUserNurse = faUserNurse;

    iconOfiti: any;
    itinerarySelections: any[] = [];
    itineraryList$ = this.store.select(itinerarySelectors.getItineraryList);
    // user globals
    USER_ID: string; //
    USER_EMAIL: string; //
    USER_ID$ = this.store.select(userSelectors.getUserID);
    USER_EMAIL$ = this.store.select(userSelectors.getUserEmail);
    // itinerary item dates
    rows: any[] = [];
    savedItem: any = {};

    customAlertOptions: any = {
        cssClass: 'time-selection',
    };

    constructor(
        private warning: WarningService,
        private store: Store<State>,
        private programService: ProgramService,
        private navCtrl: NavController,
        private applicationService: ApplicationService,
        private modalService: ModalService
    ) {}

    ngOnChanges() {
        if (this.chainItem) {
            this.setIcons();
        }
    }

    setIcons(): void {
        switch (this.chainItem.type) {
            case 'Hands-On':
                this.iconOfiti = faStethoscope;
                break;
            case 'Observership':
                this.iconOfiti = faNotesMedical;
                break;
            case 'Nursing':
                this.iconOfiti = faUserNurse;
                break;
            case 'Dentistry':
                this.iconOfiti = faTooth;
                break;
            case 'Virtual':
                this.iconOfiti = faLaptopMedical;
                break;
            case 'Virtual Pre-med shadowing':
                this.iconOfiti = faLaptopMedical;
                break;
            case 'Research':
                this.iconOfiti = faBookMedical;
                break;
            case 'Pre-med shadowing':
                this.iconOfiti = faBriefcaseMedical;
                break;
            default:
                this.iconOfiti = faNotesMedical;
                break;
        }
    }

    applicationRouting(application: any) {
        const query = this.createQuery(application);
        var applicationChainId = application.ApplicationChainMap.applicationchainid;
        if (
            (application.states === 'Pending' ||
                application.states === 'Pending-Booked' ||
                application.states === 'Pre-Approved' ||
                application.states === 'Completed') &&
            application.Program.preapprovalrequired === true
        ) {
            this.navCtrl.navigateRoot(['/application/' + application.id]);
        } else if (application.states === 'Pending' && application.madedeposit === false && application.Program.preapprovalrequired === false) {
            this.navCtrl.navigateRoot(['/payment-booking'], {
                queryParams: {
                    applicationid: application.id,
                    type: 'booking-payment',
                },
            });
        } else if (application.madedeposit === false && application.madepayment === false) {
            this.navCtrl.navigateRoot(['/payment/'], {
                queryParams: { chainid: applicationChainId },
            });
        } else if (application.signedcontract === null) {
            this.navCtrl.navigateRoot(['/application/' + application.id + '/clinical-agreement'], { queryParams: query });
        } else if (application.signedcontract === null) {
            this.navCtrl.navigateRoot(['/application/' + application.id + '/clinical-agreement'], { queryParams: query });
        } else {
            this.navCtrl.navigateRoot(['/application/' + application.id]);
        }
    }

    private createQuery(application: any): any {
        var applicationChainId = application.ApplicationChainMap.applicationchainid;

        const query =
            application.states === 'Pending' || application.states === 'Pending-Booked' || application.states === 'Pre-Approved'
                ? {}
                : !application.requiresPayment && !application.signedcontract
                ? {
                      applicationId: application.id,
                      userid: application.userid,
                      chainid: applicationChainId,
                  }
                : !application.requiresPayment
                ? {}
                : application.madedeposit
                ? {
                      applicationid: application.id,
                      type: 'final-payment',
                      chainid: applicationChainId,
                  }
                : {
                      applicationid: application.id,
                      type: 'first-payment',
                      chainid: applicationChainId,
                  };

        return query;
    }

    async cancelApplication(chainItem: any) {
        const result = await this.modalService.confirmation({
            title: 'Cancel Application',
            message: `
  You are about to cancel your application for: \n\n
  ${chainItem.specialty}, \n\n
  ${chainItem.name} \n\n
  `,
            buttonText: `Yes, cancel this application.`,
            buttonColor: 'danger',
        });

        if (result.data.confirmed) {
            this.applicationService.cancelApplication(chainItem.id).subscribe((res: any) => {
                // const url = this.router
                //     .createUrlTree(['/dashboard'])
                //     .toString();
                // this.location.replaceState(url);

                window.location.reload();
            });
        }
    } // end cancel application
}
